import { InjectionToken } from "@angular/core";
import { ISplashLoaderStateService } from "./i-splash-loader-state.service";

export const splashLoaderStateServiceInjectionToken: InjectionToken<ISplashLoaderStateService> = new InjectionToken<ISplashLoaderStateService>("digital-signage.user-dashboard.dashboard-web.SplashLoaderStateService");
